import React, { FC } from 'react'
import { BorderBody, ProgressBar } from './NormalProgressBar.styles'

interface INormalProgressBar {
    progress: string
}

const NormalProgressBar: FC<INormalProgressBar> = ({ progress }) => {
  return (
    <BorderBody>
        <ProgressBar style={{width: `${progress}%`,}}></ProgressBar>
    </BorderBody>
  )
}

export default NormalProgressBar